<template>
  <div>
    <div class="check-container">
      <div class="left-container">
        <div class="left-top">
          <div class="info-title">{{ lanpack.info }}</div>
          <el-row class="info-container">
            <el-col :span="item.span" v-for="(item, index) in infoDetails" :key="index">
              <div class="detail-title">{{ lanpack[item.title] }}</div>
              <div class="detail-content">{{ item.detail }}</div>
            </el-col>
          </el-row>
        </div>
        <div class="left-middle">
          <div class="info-title">{{ lanpack.access }}</div>
          <el-row :gutter="15">
            <el-col :span="12">
              <div class="access-item" style="margin: 15px 0 15px 15px">
                <img class="access-icon" src="~assets/pics/wh/vpn.png" alt="ivpn" />
                <div class="access-title">{{ lanpack.ivpn }}:</div>
                <div class="access-status">
                  {{ lanpack.enable }}
                </div>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="access-item" style="margin: 15px 15px 15px 0">
                <img class="access-icon" src="~assets/pics/wh/token.png" alt="token" />
                <div class="access-title" style="width: 25%">{{ lanpack.token }}:</div>
                <div
                  class="access-status"
                  style="width: 55%; text-align: left"
                  v-bind:style="tokenStatus ? '' : 'color: #f34500'"
                >
                  {{ tokenStatus ? lanpack.bind : lanpack.unbind }}
                </div>
                <el-tooltip
                  :content="languages.conf"
                  :visible-arrow="false"
                  placement="bottom"
                  popper-class="tooltip-style"
                >
                  <img
                    class="access-doc"
                    src="~assets/pics/wh/doc.png"
                    @click="openDoc('tokenUrl', 'token_doc')"
                    alt="doc"
                  />
                </el-tooltip>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="access-item" style="margin: 0 0 15px 15px">
                <img class="access-icon" src="~assets/pics/wh/remote.png" alt="ivpn" />
                <div class="access-title">{{ lanpack.remote }}:</div>
                <div class="access-status" v-if="remoteConfig">{{ lanpack.config }}</div>
                <div class="access-status" v-else>
                  <img class="access-wrong" src="~assets/pics/wh/wrong.png" alt="wrong" />
                  <div class="access-button" @click="goConfig">{{ lanpack.goConfig }}</div>
                </div>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="access-item" style="margin: 0 15px 15px 0px">
                <img class="access-icon2" src="~assets/pics/wh/certificate.png" alt="ivpn" />
                <div class="access-title">{{ lanpack.cer }}:</div>
                <div class="access-status">{{ lanpack.installed }}</div>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="left-bottom">
          <div class="info-title">{{ lanpack.softInstall }}</div>
          <div style="margin-top: 20px">
            <div
              class="soft-container"
              v-bind:class="index + 1 !== softList.length ? 'bottom-line' : ''"
              v-for="(item, index) in softList"
              :key="item.icon"
            >
              <img class="soft-icon" :src="require(`assets/pics/wh/${item.icon}.png`)" alt="" />
              <div class="soft-details">
                <div class="soft-title">
                  {{ lanpack[item.title] }}
                  <el-tag type="danger" size="mini" v-if="!item.installed">
                    {{ lanpack.notInstalled }}
                  </el-tag>
                  <!-- <el-tag size="mini"
                          v-if="item.installed && item.title==='atrust'">
                    {{lanpack.config}}
                  </el-tag> -->
                </div>
                <div class="soft-desc">{{ lanpack[item.desc] }}</div>
              </div>
              <el-dropdown
                trigger="click"
                class="dropdown-item"
                v-if="item.installed"
                @command="goInstall(item.button,true)"
              >
                <div class="soft-button installed">
                  {{ lanpack.installed }}
                  <i class="el-icon-caret-bottom"></i>
                </div>
                <template #dropdown>
                  <el-dropdown-menu style="padding: 5px 0">
                    <el-dropdown-item :command="item">
                      {{ item.title === 'safe' ? lanpack.goApply : languages.reinstall }}
                      <img class="icon-install" src="~assets/pics/arrow.png" alt="install" />
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
              <!-- installed button -->
              <div class="dropdown-item" v-if="!item.installed">
                <div class="soft-button" @click="goInstall(item.button,false)">
                  {{ item.title === 'safe' ? lanpack.goApply : lanpack.goInstall }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right-container">
        <div class="right-top">
          <div class="info-title">{{ lanpack.environment }}</div>
          <div class="env-container">
            <div class="env-title">{{ lanpack.network }}</div>
            <img class="env-icon" src="~assets/pics/wh/net.png" alt="net" />
            <div class="env-button" @click="handleNetCheck">{{ lanpack.netTest }}</div>
            <div class="env-status">
              <div class="status-title">{{ lanpack.intranet }}:</div>
              <div v-if="intranetOk === ''" class="status-detail">{{ lanpack.untest }}</div>
              <div v-else class="status-detail">
                <img
                  :src="require(`assets/pics/wh/${intranetOk ? 'right' : 'wrong'}.png`)"
                  alt=""
                />
              </div>
            </div>

            <div class="env-status">
              <div class="status-title">{{ lanpack.internet }}:</div>
              <div v-if="internetOk === ''" class="status-detail">{{ lanpack.untest }}</div>
              <div v-else class="status-detail">
                <img
                  :src="require(`assets/pics/wh/${internetOk ? 'right' : 'wrong'}.png`)"
                  alt=""
                />
              </div>
            </div>
            <div class="env-status"></div>
          </div>
          <div class="env-container">
            <div class="env-title">{{ lanpack.media }}</div>
            <img class="env-icon" src="~assets/pics/wh/meeting.png" alt="net" />
            <div class="env-button" @click="handleMediaCheck">{{ lanpack.mediaCheck }}</div>
            <div class="env-status">
              <div class="status-title">{{ lanpack.camera }}:</div>
              <div v-if="hasCamera === ''" class="status-detail">{{ lanpack.untest }}</div>
              <div v-else class="status-detail">
                <img :src="require(`assets/pics/wh/${hasCamera ? 'right' : 'wrong'}.png`)" alt="" />
              </div>
            </div>

            <div class="env-status">
              <div class="status-title">{{ lanpack.microphone }}:</div>
              <div v-if="hasMic === ''" class="status-detail">{{ lanpack.untest }}</div>
              <div v-else class="status-detail">
                <img :src="require(`assets/pics/wh/${hasMic ? 'right' : 'wrong'}.png`)" alt="" />
              </div>
            </div>
            <div class="env-status">
              <div class="status-title">{{ lanpack.audio }}:</div>
              <div v-if="hasAudio === ''" class="status-detail">{{ lanpack.untest }}</div>
              <div v-else class="status-detail">
                <img :src="require(`assets/pics/wh/${hasAudio ? 'right' : 'wrong'}.png`)" alt="" />
              </div>
            </div>
            <div class="env-status"></div>
          </div>
          <!-- <div class="env-container">
            <div class="env-title">{{ lanpack.mic }}</div>
            <img class="env-icon" src="~assets/pics/wh/test.png" alt="net" />
            <div
              class="env-button"
              v-bind:style="languages.lan === 'en' ? 'width:100px' : ''"
              style="margin: 5px auto"
              @click="handleCallTest('OUT')"
            >
              {{ lanpack.outbound }}
            </div>
            <div
              class="env-button"
              v-bind:style="languages.lan === 'en' ? 'width:100px' : ''"
              style="margin: 5px auto"
              @click="handleCallTest('IN')"
            >
              {{ lanpack.inbound }}
            </div>
            <div class="env-status">
              <div class="status-title">{{ lanpack.callout }}:</div>
              <div v-if="CallOutResult !== ''" class="status-detail">
                {{ lanpack[CallOutResult] }}
              </div>
              <div v-if="CallOutResult === ''" class="status-detail">{{ lanpack.untest }}</div>
            </div>
            <div class="env-status">
              <div class="status-title">{{ lanpack.callin }}:</div>
              <div v-if="CallInResult !== ''" class="status-detail">
                {{ lanpack[CallInResult] }}
              </div>
              <div v-if="CallInResult === ''" class="status-detail">{{ lanpack.untest }}</div>
            </div>
            <div class="env-tip">
              {{ lanpack.headsetTip }}
            </div>
          </div> -->
        </div>
        <div class="right-bottom">
          <div class="info-title">{{ lanpack.document }}</div>
          <div class="doc-container">
            <div class="doc-item">
              <img class="doc-icon" src="~assets/pics/wh/doc.png" alt="doc" />
              <div class="doc-content" @click="openDoc('tokenUrl','vpn_doc')">
                {{ lanpack.vpnTitle }}
              </div>
            </div>
            <div class="doc-item">
              <img class="doc-icon" src="~assets/pics/wh/doc.png" alt="doc" />
              <div class="doc-content" @click="openDoc('phoneDoc', 'phone_doc')">
                {{ lanpack.phoneTitle }}</div>
            </div>
          </div>
          <div class="doc-container" style="margin-top: 0">
            <div class="doc-item">
              <img class="doc-icon" src="~assets/pics/wh/doc.png" alt="doc" />
              <div class="doc-content" @click="openDoc('atrustConfig', 'atrust_doc')">
                {{ lanpack.atrustConfigTitle }}
              </div>
            </div>
            <div class="doc-item" style="opacity: 0"></div>
          </div>
          <div class="report-button" @click="handleReport">{{ lanpack.report }}</div>
        </div>
      </div>
    </div>
    <media-check-dialog :show="dialogMediaVisible" :languages="lanpack"></media-check-dialog>
    <!-- <web-check-dialog
      :show="dialogWebCheckVisible"
      :socketData="homeData"
      :lan="languages.lan"
      :networks="networkDetails"
      :lanpack="lanpack"
    ></web-check-dialog> -->
    <network-check-dialog
      :show="dialogWebCheckVisible"
      :socketData="homeData"
      :lan="languages.lan"
      :networks="networkDetails"
      from="HomeCheck"
      :lanpack="languages.NetWorkCheck"
    ></network-check-dialog>
    <el-dialog
      :visible.sync="dialogReportVisible"
      top="20%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      width="400px"
    >
      <div class="error-container">
        <div class="error-tips">
          {{ lanpack.checkTip }}
        </div>
        <div class="error-content">{{ reportData }}</div>
        <div class="error-tips2">* {{ lanpack.checkTip2 }}</div>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button :disabled="isChecking" @click="cancelReport">{{ lanpack.cancel }}</el-button>
          <el-button type="primary" :loading="isReporting" @click="reportErrors">{{
            lanpack.confirm
          }}</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import MediaCheckDialog from 'components/dialogs/MediaCheckDialog.vue';
// import WebCheckDialog from 'components/dialogs/WebCheckDialog.vue';
import { mapMutations, mapActions, mapState } from 'vuex';
import { Loading } from 'element-ui';
import socket from 'common/socket';
import tools from 'common/tools';
import NetworkCheckDialog from 'components/dialogs/NetworkCheckDialog.vue';
import { ubtRegister, ubtSendTrace } from '../../utils/ubt';

export default {
  inject: ['homeTemplate'],
  data() {
    return {
      dialogMediaVisible: false,
      dialogWebCheckVisible: false,
      dialogReportVisible: false,
      isChecking: true,
      isReporting: false,
      reportData: '',
      homeData: {},
      loading: '',
      workhomeInfo: '',
      intranetOk: '',
      internetOk: '',
      networkChecked: false,
      mediaChecked: false,
      phoneChecked: false,
      hasCamera: '',
      hasMic: '',
      hasAudio: '',
      infoDetails: [],
      vpnStatus: false,
      tokenStatus: false,
      remoteConfig: false,
      CallTestQueryInterval: '',
      CallInResult: '',
      CallOutResult: '',
      softList: [
        {
          icon: 'atrust',
          title: 'atrust',
          desc: 'atrustDesc',
          button: 'ATRUST',
          installed: false,
        },
        {
          icon: 'implus',
          title: 'implus',
          desc: 'imDesc',
          button: 'im+',
          installed: false,
        },
        {
          icon: 'safe',
          title: 'safe',
          desc: 'safeDesc',
          button: 'safe',
          installed: false,
        },
        {
          icon: 'zoom',
          title: 'zoom',
          desc: 'zoomDesc',
          button: 'zoom',
          installed: false,
        },
      ],
      networkDetails: '',
      pvId: '',
    };
  },
  computed: {
    ...mapState(['languages', 'userInfo', 'deviceName', 'toolList', 'mockMode']),
    lanpack() {
      return this.languages.homeCheck;
    },
  },
  destroyed() {
    clearInterval(this.CallTestQueryInterval);
    this.setLanChange(true);
    this.loading.close();
  },
  components: {
    MediaCheckDialog,
    // WebCheckDialog,
    NetworkCheckDialog,
  },
  methods: {
    ...mapMutations([
      'setDebugInfos',
      'setPageNow',
      'setHomeHidden',
      'setSearchHidden',
      'setShowFooter',
      'setSoftSearch',
      'handleSoftSearch',
      'setErrorTips',
      'setErrorType',
      'setLanChange',
    ]),
    ...mapActions([
      'hwCheck',
      'softwareInstall',
      'softApply',
      'reportError',
      'saveLog',
      'getCallTestResult',
      'getCallTestResultQuery',
    ]),
    getInfoDetails() {
      this.infoDetails[0] = { span: 12, title: 'userName', detail: this.userInfo.displayName };
      this.infoDetails[1] = { span: 6, title: 'empCode', detail: this.userInfo.empcode };
      this.infoDetails[2] = { span: 6, title: 'pcName', detail: this.deviceName };
    },
    async runTool() {
      this.workhomeInfo = this.toolList.filter(
        (item) => item.name.indexOf('WorkHomeStatus') !== -1,
      );
      if (this.workhomeInfo.length !== 1) {
        this.setDebugInfos(['HomeCheck > little tool check', 'No such little tool']);
        this.setErrorTips('HomeCheck > getHomeCheckInfo > No such little tool');
        this.saveLog({
          title: 'api_error',
          target: 'HomeCheck > getHomeCheckInfo',
          description: 'No such little tool!',
        });
        this.setErrorType('apierror');
        this.$router.push('/error');
        return;
      }
      // local tool check
      const res = await this.softwareInstall({
        account: this.userInfo.username,
        softwareId: this.workhomeInfo[0].id,
        pcName: this.deviceName,
      });
      if (res.status === 'failed') {
        this.setDebugInfos(['HomeCheck > softwareInstall', res.data]);
        this.setErrorTips(`HomeCheck > softwareInstall > ${res.data}`);
        this.saveLog({
          title: 'api_error',
          target: 'HomeCheck > softwareInstall',
          description: res.data,
        });
        this.setErrorType('apierror');
        this.$router.push('/error');
        return;
      }
      const workhomeData = {
        lan: 'tools',
        type: 'silent',
        username: this.userInfo.username,
        softid: this.workhomeInfo[0].id,
        path: res.data.encryptPath,
        key: res.data.key,
      };
      this.homeData = workhomeData;
      const socketDatas = tools.toUnicode(JSON.stringify(workhomeData));
      this.homeTemplate.downToolNew('WorkHomeStatus', this.workhomeInfo[0].id, res, (cb) => {
        if (cb === 'Down Failed') {
          this.loading.close();
          this.$router.push('home_grid');
          return;
        }
        const runCmd = `({"level":"user", "method":"tool_run", "data":"${socketDatas}"})`;
        socket.sendSocket(2, runCmd, (rt) => {
          const rst = JSON.parse(rt);
          if (rst.result === 'failed') {
            this.setErrorTips(`HomeCheck > toolrun > ${rst.error}`);
            this.saveLog({
              title: 'command_error',
              target: 'runTool',
              description: rst.error,
              reserve1: 'HomeCheck > toolrun',
            });
            this.setErrorType('apierror');
            this.$router.push('/error');
            return;
          }
          if (rst.data === 'Tool Exited') {
            console.log('Tool Exited', rst);
            this.networkDetails = JSON.parse(rst.info).networks;
            this.handleHomeVals(JSON.parse(rst.info));
          }
        });
      });
    },
    handleHomeVals(homeVals) {
      this.setDebugInfos(['HomeCheck > homeVals', homeVals]);
      this.loading.close();
      this.isChecking = false;
      this.softList[0].installed = homeVals.atrust === 'YES';
      this.softList[1].installed = homeVals['im+'] === 'YES';
      this.softList[2].installed = homeVals.dlp === 'YES';
      this.softList[3].installed = homeVals.zoom === 'YES';
      this.remoteConfig = homeVals.remote === 'YES';
      if (homeVals.cert === 'ADD') {
        this.saveLog({
          title: 'HomeCheck',
          target: 'Add Cert',
          description: 'Import Ctrip Root Cert',
        });
      }
    },
    async getVpnToken() {
      const hwResult = await this.hwCheck();
      if (hwResult.status === 'failed') {
        this.setErrorTips('HomeCheck > getVpnToken > api_error');
        this.saveLog({
          title: 'api_error',
          target: 'getVpnToken',
          description: hwResult.data,
        });
      } else {
        this.vpnStatus = hwResult.data.vpnStatus;
        this.tokenStatus = hwResult.data.vpnTokenStatus;
      }
    },
    openDoc(doc, btnType) {
      tools.openUrl(this.lanpack[doc]);
      ubtSendTrace(245694, 'remote_status', 'helpdoc', btnType, '', '', this.pvId);
    },
    goInstall(soft, installed) {
      ubtSendTrace(245694, 'remote_status', installed ? 'reinstall' : 'install', soft, soft, '', this.pvId);
      if (soft === 'safe') {
        tools.openUrl(this.lanpack.softRequest);
        return;
      }
      this.$router.push('/SoftwareInstall');
      setTimeout(() => {
        this.setSoftSearch(soft);
        this.handleSoftSearch(soft);
      }, 500);
    },
    goConfig() {
      this.homeTemplate.goHome();
      setTimeout(() => {
        this.$root.$emit('goApply', 'add_remote');
      }, 300);
    },
    handleNetCheck() {
      this.networkChecked = false;
      this.dialogWebCheckVisible = true;
      this.saveLog({
        title: 'HomeCheck',
        target: 'NetCheck',
        description: 'Open Network Check',
      });
      ubtSendTrace(245694, 'remote_status', 'click', 'network_check', '', '', this.pvId);
    },
    handleMediaCheck() {
      // it doesn't work if not localhost!
      this.hasCamera = '';
      this.hasMic = '';
      this.hasAudio = '';
      this.mediaChecked = false;
      this.dialogMediaVisible = true;
      this.saveLog({
        title: 'HomeCheck',
        target: 'MediaCheck',
        description: 'Media Check',
      });
      setTimeout(() => {
        this.hasCamera = '';
        this.hasMic = '';
        this.hasAudio = '';
      }, 300);
      ubtSendTrace(245694, 'remote_status', 'click', 'device_check', '', '', this.pvId);
    },
    hideNetcheckDialog(inChk, outChk) {
      this.intranetOk = inChk;
      this.internetOk = outChk;
      this.networkChecked = true;
      this.dialogWebCheckVisible = false;
    },
    hideMediaDialog(val) {
      this.hasCamera = '';
      this.hasMic = '';
      this.hasAudio = '';
      if (val[0].status !== 0) this.hasCamera = val[0].status === 1;
      if (val[1].status !== 0) this.hasMic = val[1].status === 1;
      if (val[2].status !== 0) this.hasAudio = val[2].status === 1;
      this.mediaChecked = true;
      this.dialogMediaVisible = false;
    },
    async handleCallTest(type) {
      const timeNow = new Date();
      const result = await this.getCallTestResult(type);
      if (result !== 'success') {
        const testType = type === 'IN' ? this.lanpack.inbound : this.lanpack.outbound;
        this.$message.warning({ message: testType + this.lanpack.failTip, duration: 5000 });
        this.setDebugInfos([`HomeCheck > Call ${type} Check`, result]);
        this.setErrorTips(`HomeCheck > Call ${type} Check > ${result}`);
        this.saveLog({
          title: 'HomeCheck',
          target: 'PhoneCheck',
          description: 'Phone Check failed',
          reserve1: type,
          reserve2: result,
        });
        ubtSendTrace(245694, 'remote_status', 'click', type === 'IN' ? 'in_phone' : 'out_phone', '', '', this.pvId, result);
        return;
      }
      ubtSendTrace(245694, 'remote_status', 'click', type === 'IN' ? 'in_phone' : 'out_phone', '', '', this.pvId);
      this.saveLog({
        title: 'HomeCheck',
        target: 'PhoneCheck',
        description: 'Phone Check',
        reserve1: type,
      });
      this.phoneChecked = true;
      let checkIndex = 0;
      this.CallTestQueryInterval = setInterval(async () => {
        checkIndex += 1;
        if (checkIndex >= 90) {
          clearInterval(this.CallTestQueryInterval);
          return;
        }
        const rst = await this.getCallTestResultQuery(type);
        console.log(rst);
        if (rst !== '' && rst.length === 1) {
          const { createTime, testResult, callType } = rst[0];
          if (new Date(createTime) > timeNow) {
            clearInterval(this.CallTestQueryInterval);
            if (callType === 'IN') {
              this.CallInResult = this.getCallStatus(testResult);
              return;
            }
            if (callType === 'OUT') this.CallOutResult = this.getCallStatus(testResult);
          }
        }
      }, 2000);
    },
    handleReport() {
      this.reportData = '';
      // vpn and token check
      if (!this.tokenStatus) this.reportData += `${this.lanpack.token}: ${this.lanpack.unbind}; `;
      // software check
      this.softList.forEach((item) => {
        if (!item.installed) {
          this.reportData += `${this.lanpack[item.title]}: ${this.lanpack.uninstall}; `;
        }
      });

      // network check
      if (!this.networkChecked) {
        this.reportData += `${this.lanpack.network}: ${this.lanpack.untest}; `;
      } else {
        let netCheckData = '';
        if (this.intranetOk === false) netCheckData += `${this.lanpack.inoutNet} x `;
        if (this.internetOk === false) netCheckData += `${this.lanpack.custom} x `;
        if (netCheckData !== '') this.reportData += `${this.lanpack.network}: ${netCheckData}; `;
      }

      // media check
      if (!this.mediaChecked) {
        this.reportData += `${this.lanpack.media}: ${this.lanpack.untest}; `;
      } else {
        let mediaInfo = '';
        if (!this.hasCamera) mediaInfo += `${this.lanpack.camera} x `;
        if (!this.hasMic) mediaInfo += `${this.lanpack.microphone} x `;
        if (!this.hasAudio) mediaInfo += `${this.lanpack.audio} x `;
        if (mediaInfo !== '') this.reportData += `${this.lanpack.media}: ${mediaInfo}; `;
      }

      // phone check
      if (!this.phoneChecked) {
        this.reportData += `${this.lanpack.mic}: ${this.lanpack.untest}; `;
      } else {
        if (this.CallInResult !== '' && this.CallInResult !== 'goodStatus') {
          this.reportData += `${this.lanpack.inbound}: ${this.lanpack[this.CallInResult]}; `;
        }
        if (this.CallOutResult !== '' && this.CallOutResult !== 'goodStatus') {
          this.reportData += `${this.lanpack.outbound}: ${this.lanpack[this.CallOutResult]}; `;
        }
      }
      this.reportData = this.reportData.replaceAll('\n', ' ').replaceAll('; ', ';\n');
      console.log(this.reportData);
      this.dialogReportVisible = true;
    },
    cancelReport() {
      this.dialogReportVisible = false;
      this.isChecking = false;
    },
    async reportErrors() {
      const pcName = this.deviceName;
      let phone = '';
      const { empcode, displayName } = this.userInfo;
      const userBaseInfo = await this.softApply({ type: 'baseinfo' });
      if (userBaseInfo.status === 'success') {
        const userInfo = userBaseInfo.data;
        phone = userInfo.phone;
      }
      this.isChecking = true;
      this.isReporting = true;
      const reportResult = await this.reportError({
        lan: this.languages.lan,
        empCode: empcode,
        displayName,
        phone,
        pcName,
        description: this.reportData,
      });
      // console.log(reportResult, this.reportData, empcode, displayName, pcName, phone);
      switch (reportResult) {
        case 'success':
          this.$message.success(this.lanpack.reportSuccess);
          break;
        case 'limit':
          this.$message.warning({ message: this.lanpack.reportLimit, duration: 5000 });
          break;
        default:
          this.$message.warning({ message: this.lanpack.reportFail, duration: 5000 });
          break;
      }
      this.saveLog({
        title: 'HomeCheck',
        target: 'ReportErrors',
        description: this.reportData,
      });
      this.reportData = '';
      this.dialogReportVisible = false;
      this.isReporting = false;
      this.isChecking = false;
      ubtSendTrace(245694, 'remote_status', 'help', '', '', 'eventhelp', this.pvId);
    },
    getCallStatus(type) {
      let status = '';
      switch (type) {
        case 'GOOD':
          status = 'goodStatus';
          break;
        case 'BAD':
          status = 'badStatus';
          break;
        case 'NO_SOUND':
          status = 'noSound';
          break;
        case 'NO_ANSWER':
          status = 'noAnswer';
          break;
        case 'NO_RESULT':
          status = 'noResult';
          break;
        default:
          break;
      }
      return status;
    },
  },
  created() {
    this.setPageNow('HomeCheck');
    this.setHomeHidden(false);
    this.setSearchHidden(true);
    this.setShowFooter(false);
    // this.setLanChange(false);
    this.loading = Loading.service({
      fullscreen: true,
      text: this.lanpack.checking,
      background: 'rgba(0, 0, 0, 0.7)',
    });
    this.setErrorTips('');
    this.getInfoDetails();
    if (!this.mockMode) this.getVpnToken();
    this.runTool();
    this.pvId = ubtRegister('WFH Preparation');
  },
};
</script>

<style lang="scss" scoped>
.error-container {
  display: flex;
  flex-direction: column;
  align-content: center;
  .error-tips {
    font-size: 16px;
    margin-left: 20px;
  }
  .error-tips2 {
    font-size: 14px;
    margin-left: 20px;
    color: #f56c6c;
  }
  .error-content {
    white-space: pre-wrap;
    padding: 10px 35px;
  }
}
.check-container {
  position: absolute;
  top: 70px;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 20px;
  display: flex;
  .left-container,
  .right-container {
    width: 50%;
    display: flex;
    flex-direction: column;
    .info-title {
      position: relative;
      left: 15px;
      top: 10px;
      font-size: 16px;
      font-weight: 600;
      color: #333;
    }
    .left-top,
    .left-middle,
    .left-bottom,
    .right-top,
    .right-bottom {
      border-radius: 16px;
      background-color: #f2f7ff;
      margin-bottom: 20px;
    }
  }
  .left-container {
    margin-right: 10px;
    .left-top {
      height: 120px;
      .info-container {
        border-radius: 4px;
        background-color: #fff;
        margin: 15px;
        padding: 10px;
        min-height: 60px;
        .detail-title {
          font-size: 12px;
          color: #666;
          margin-bottom: 5px;
        }
        .detail-content {
          font-size: 14px;
          color: #1466de;
        }
      }
    }
    .left-middle {
      height: 230px;
      .access-item {
        border-radius: 4px;
        background-color: #fff;
        text-align: center;
        height: 32px;
        line-height: 32px;
        position: relative;
        font-size: 12px;
        .access-icon {
          position: absolute;
          width: 28px;
          height: 28px;
          left: 10px;
          top: 2px;
        }
        .access-icon2 {
          position: absolute;
          width: 20px;
          height: 20px;
          left: 15px;
          top: 8px;
        }
        .access-title {
          position: absolute;
          color: #333;
          left: 40px;
          width: 35%;
        }
        .access-status {
          position: absolute;
          color: #00b87a;
          right: 0;
          width: 45%;
        }
        .access-doc {
          position: absolute;
          right: 5px;
          width: 26px;
          height: 26px;
          top: 3px;
          cursor: pointer;
        }
        .access-wrong {
          position: absolute;
          color: red;
          right: 90px;
          width: 18px;
          height: 18px;
          top: 7px;
        }
        .access-button {
          position: absolute;
          right: 5px;
          top: 4px;
          cursor: pointer;
          background: linear-gradient(-180deg, rgb(0, 183, 255) 0%, rgb(0, 128, 255) 100%);
          border-radius: 12px;
          text-align: center;
          color: #fff;
          font-size: 12px;
          line-height: 24px;
          width: 70px;
        }
      }
    }
    .left-bottom {
      margin-bottom: 0;
      height: 100%;
      .soft-container {
        position: relative;
        margin: 0 15px;
        padding: 8px 10px;
        display: flex;
        .soft-icon {
          width: 40px;
          height: 40px;
        }
        .soft-details {
          color: #666;
          margin-left: 10px;
          .soft-title {
            font-size: 14px;
            font-weight: 600;
            line-height: 20px;
            .el-tag {
              margin-left: 5px;
              margin-bottom: 2px;
            }
          }
          .soft-desc {
            font-size: 13px;
          }
        }
        .soft-button {
          cursor: pointer;
          background: linear-gradient(-180deg, rgb(0, 183, 255) 0%, rgb(0, 128, 255) 100%);
          border-radius: 13px;
          text-align: center;
          color: #fff;
          font-size: 12px;
          line-height: 26px;
        }
      }
    }
  }
  .right-container {
    margin-left: 10px;
    .right-top {
      position: relative;
      height: 60%;
      display: flex;
      padding: 10px;
      .info-title {
        position: absolute;
      }
      .env-container {
        position: relative;
        margin: 5px;
        margin-top: 25px;
        background: #fff;
        width: 50%;
        border-radius: 8px;
        text-align: center;
        font-size: 12px;
        .env-title {
          color: #666;
          height: 20px;
          margin: 10px 0;
        }
        .env-icon {
          width: 80px;
          height: 80px;
        }
        .env-button {
          width: 75px;
          margin: 21px auto;
          height: 20px;
          border-radius: 10px;
          color: #0080ff;
          line-height: 20px;
          border: 1px solid #0080ff;
          cursor: pointer;
        }
        .env-status {
          display: flex;
          margin-top: 8px;
          .status-title {
            width: 50%;
            color: #333;
            text-align: right;
          }
          .status-detail {
            width: 50%;
            color: #f34500;
            text-align: left;
            margin-left: 5px;
            position: relative;
            font-size: 10px;
            img {
              position: absolute;
              left: 8px;
              top: -2px;
              width: 20px;
            }
          }
        }

        .env-tip {
          height: 30px;
          margin-top: 10px;
          font-size: 10px;
          color: #1466de;
          padding: 0 5px;
          white-space: pre-wrap;
        }

        .env-doc {
          position: absolute;
          right: 10px;
          bottom: 10px;
          width: 26px;
          height: 26px;
          margin-top: 3px;
          cursor: pointer;
        }
      }
    }
    .right-bottom {
      position: relative;
      margin-bottom: 0;
      height: 40%;
      .info-title {
        position: absolute;
      }
      .doc-container {
        display: flex;
        text-align: center;
        margin-top: 35px;
        padding: 0 10px;
        .doc-item {
          border-radius: 4px;
          background: #fff;
          width: 100%;
          height: 50px;
          margin: 5px;
          display: flex;
          .doc-icon {
            width: 24px;
            height: 24px;
            margin: 13px 0 13px 10px;
          }
          .doc-content {
            cursor: pointer;
            line-height: 30px;
            margin: 10px;
            color: #333;
            font-size: 12px;
          }
        }
      }
      .report-button {
        width: 75px;
        height: 22px;
        line-height: 22px;
        font-size: 13px;
        border-radius: 11px;
        color: #1466de;
        border: 1px solid #0080ff;
        cursor: pointer;
        text-align: center;
        position: absolute;
        right: 15px;
        bottom: 15px;
      }
    }
  }
}
.bottom-line {
  border-bottom: 1px solid #ebeced;
}
.dropdown-item {
  position: absolute;
  right: 0;
  top: 17px;
  width: 80px;
}
.icon-install {
  position: relative;
  top: 3px;
  height: 18px;
  left: 10px;
}
.installed {
  background: #7ea3ea !important;
}
</style>
